import React, { useEffect } from "react";
import { Collapse, IconButton } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { alertStyles } from "../../styles/styles";
import { updateAlert } from "../../store/alert/actions";
import { connect } from "react-redux";

function AlertComponent(props) {
  const classes = alertStyles();

  const closeAlert = () => {
    props.dispatch(
      updateAlert({
        text: "",
        open: false,
      })
    );
  };
  useEffect(() => {
    if (props.alert.open) {
      setTimeout(closeAlert, 10000);
    }
  }, [props.alert.open]);

  return (
    <div className={classes.root}>
      <Collapse in={props.alert.open}>
        <Alert
          severity={props.alert.severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                closeAlert();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
            <AlertTitle>Hata</AlertTitle>
          {props.alert.text}
        </Alert>
      </Collapse>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert,
  };
};

export default connect(mapStateToProps)(AlertComponent);
